export default {
  // Header
  "title": "مولد بوكيمون عشوائي",
  "subtitle": "ولد شخصيات بوكيمون عشوائية حسب تفضيلاتك",
  "home": "الرئيسية",
  "whichPokemonAmI": "أي بوكيمون أنا؟",
  "aboutUs": "من نحن",
  "contactUs": "اتصل بنا",
  "privacyPolicy": "سياسة الخصوصية",
  
  // Filters
  "filterTitle": "خيارات التصفية",
  "generateButton": "توليد بوكيمون عشوائي",
  "generating": "جاري التوليد...",
  "numberOfPokemon": "عدد البوكيمون",
  "type": "النوع",
  "generation": "الجيل",
  "minimumRarity": "الندرة الأدنى (1-10)",
  "anyType": "أي نوع",
  "anyGeneration": "أي جيل",
  "anyRarity": "أي ندرة",
  "countingPokemon": "جارٍ حساب البوكيمون المطابقة",
  "matchingPokemonCount": "{{count}} بوكيمون مطابق لتصفياتك",
  "noPokemonToDisplay": "لا يوجد بوكيمون للعرض. قم بإنشاء بعض البوكيمون!",
  
  // Pokemon Types
  "normal": "عادي",
  "fire": "ناري",
  "water": "مائي",
  "electric": "كهربائي",
  "grass": "عشبي",
  "ice": "ثلجي",
  "fighting": "قتالي",
  "poison": "سام",
  "ground": "أرضي",
  "flying": "طائر",
  "psychic": "نفسي",
  "bug": "حشرات",
  "rock": "صخري",
  "ghost": "شبحي",
  "dragon": "تنين",
  "dark": "ظلامي",
  "steel": "فولاذي",
  "fairy": "جنّي",
  
  // Generations
  "Generation I": "الجيل الأول",
  "Generation II": "الجيل الثاني",
  "Generation III": "الجيل الثالث",
  "Generation IV": "الجيل الرابع",
  "Generation V": "الجيل الخامس",
  "Generation VI": "الجيل السادس",
  "Generation VII": "الجيل السابع",
  "Generation VIII": "الجيل الثامن",
  "Generation IX": "الجيل التاسع",
  
  // Evolution Stage
  "evolutionStage": "مرحلة التطور",
  "evolutionStageAll": "كل المراحل",
  "evolutionStageFullyEvolved": "متطور بالكامل",
  "evolutionStageNotFullyEvolved": "غير متطور بالكامل",
  
  // About Section
  "aboutTitle": "حول مولد بوكيمون العشوائي",
  
  // Section titles
  "introTitle": "مرحبًا بك في مولد بوكيمون العشوائي",
  "howToUseTitle": "كيفية استخدام مولد بوكيمون العشوائي",
  "benefitsTitle": "فوائد استخدام مولد بوكيمون العشوائي",
  "historyTitle": "تاريخ بوكيمون",
  "popularPokemonTitle": "شخصيات بوكيمون الشهيرة",
  "popularGamesTitle": "ألعاب بوكيمون الشهيرة",
  "tradingContestsTitle": "تبادل ومسابقات بوكيمون",
  "faqTitle": "الأسئلة المتكررة",
  "conclusionTitle": "ابدأ مغامرتك العشوائية مع بوكيمون اليوم!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "بوكيمون وأسماء شخصيات بوكيمون هي علامات تجارية لشركة نينتندو.",
  "linksTitle": "روابط مفيدة",
  
  // About Us Page
  "aboutUsTitle": "من نحن",
  "aboutUsWhoWeAre": "من نحن",
  "aboutUsWhoWeAreContent1": "مرحبًا بك في مولد بوكيمون العشوائي، وهي أداة من صنع المعجبين تم إنشاؤها بواسطة متحمسين لبوكيمون. بدأت رحلتنا في عام 2023 عندما قررت مجموعة من المطورين الذين يحبون البرمجة وبوكيمون إنشاء أداة مفيدة للمجتمع.",
  "aboutUsWhoWeAreContent2": "يتكون فريقنا من مطورين ومصممين ومنشئي محتوى يعملون معًا لتقديم أفضل تجربة لمحبي بوكيمون حول العالم.",
  "aboutUsOurMission": "مهمتنا",
  "aboutUsOurMissionContent1": "نهدف إلى جعل عالم بوكيمون أكثر سهولة ومتعة للجميع. تم تصميم أدواتنا لمساعدة المدربين على اكتشاف بوكيمون جديدة، وإنشاء فرق متوازنة، والعثور على بوكيمون المثالي.",
  "aboutUsOurMissionContent2": "نحن ملتزمون بتقديم تجربة سهلة الاستخدام ودقيقة وممتعة تحترم امتياز بوكيمون مع إضافة قيمة للمجتمع.",
  "aboutUsOurTeam": "فريقنا",
  "aboutUsOurTeamContent1": "يجمع فريقنا المتنوع بين الخبرات في تطوير الويب ومعرفة بوكيمون وتصميم تجربة المستخدم وإدارة المجتمع. نحن متحدون بحبنا لبوكيمون والتزامنا بإنشاء أدوات عالية الجودة.",
  "aboutUsOurTeamContent2": "يساهم كل عضو في الفريق بمهاراته ووجهات نظره الفريدة لجعل مولد بوكيمون العشوائي أفضل ما يمكن.",
  "aboutUsJoinUs": "انضم إلينا",
  "aboutUsJoinUsContent": "نحن دائمًا نبحث عن أشخاص متحمسين للانضمام إلى مجتمعنا. سواء كنت مطورًا أو مصممًا أو خبيرًا في بوكيمون أو مستخدمًا متحمسًا، فإن ملاحظاتك ومساهماتك موضع ترحيب.",
  
  // Contact Us Page
  "contactUsTitle": "اتصل بنا",
  "contactUsGetInTouch": "تواصل معنا",
  "contactUsGetInTouchContent": "هل لديك أسئلة أو اقتراحات أو ملاحظات حول مولد بوكيمون العشوائي؟ نود أن نسمع منك! فيما يلي كيفية الاتصال بفريقنا.",
  "contactUsEmail": "البريد الإلكتروني",
  "contactUsPhone": "الهاتف",
  "contactUsAddress": "العنوان",
  "contactUsHelpSupport": "المساعدة والدعم",
  "contactUsHelpSupportContent": "هل تحتاج إلى مساعدة في استخدام أدواتنا أو واجهت مشكلة؟ فريق الدعم لدينا هنا للمساعدة.",
  "contactUsFAQ": "الأسئلة المتكررة",
  "contactUsFAQContent": "قبل الاتصال بنا، يرجى التحقق من قسم الأسئلة المتكررة الذي يغطي العديد من الأسئلة والمشكلات الشائعة.",
  "contactUsBugReport": "الإبلاغ عن خلل",
  "contactUsBugReportContent": "إذا وجدت خللاً أو مشكلة تقنية، يرجى إخبارنا عن طريق إرسال بريد إلكتروني مع عنوان 'تقرير خلل'.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "سياسة الخصوصية",
  "privacyPolicyIntro": "مقدمة",
  "privacyPolicyIntroContent": "في مولد بوكيمون العشوائي، نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك عند استخدام موقعنا الإلكتروني.",
  "privacyPolicyInformation": "المعلومات التي نجمعها",
  "privacyPolicyInformationContent": "نجمع الحد الأدنى من المعلومات لتقديم وتحسين خدماتنا. قد يشمل ذلك:",
  "privacyPolicyInformationItem1": "بيانات الاستخدام (مثل الصفحات التي تمت زيارتها، والوقت المستغرق على الموقع، والميزات المستخدمة)",
  "privacyPolicyInformationItem2": "معلومات الجهاز (نوع المتصفح، ونظام التشغيل، ودقة الشاشة)",
  "privacyPolicyInformationItem3": "عنوان IP والموقع التقريبي (على مستوى البلد فقط)",
  "privacyPolicyCookies": "ملفات تعريف الارتباط والتقنيات المماثلة",
  "privacyPolicyCookiesContent": "نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا. تسمح لنا ملفات النص الصغيرة هذه بتذكر تفضيلاتك وتحليل استخدام موقعنا. يمكنك التحكم في ملفات تعريف الارتباط من خلال إعدادات المتصفح.",
  "privacyPolicyThirdParty": "خدمات الطرف الثالث",
  "privacyPolicyThirdPartyContent": "قد يستخدم موقعنا خدمات الطرف الثالث مثل مزودي التحليلات وشبكات توصيل المحتوى. قد تجمع هذه الخدمات معلومات حول استخدامك لموقعنا. نحن نضمن أن جميع الأطراف الثالثة تحترم خصوصيتك وتعالج البيانات بشكل مناسب.",
  "privacyPolicySecurity": "أمن البيانات",
  "privacyPolicySecurityContent": "نحن ننفذ تدابير أمنية مناسبة لحماية معلوماتك من الوصول غير المصرح به أو التعديل أو الإفصاح. ومع ذلك، لا يوجد نقل عبر الإنترنت آمن بنسبة 100٪، لذلك لا يمكننا ضمان الأمان المطلق.",
  "privacyPolicyChanges": "تغييرات على هذه السياسة",
  "privacyPolicyChangesContent": "قد نقوم بتحديث سياسة الخصوصية الخاصة بنا من وقت لآخر. سنعلمك بأي تغييرات من خلال نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث تاريخ 'آخر تحديث'.",
  "privacyPolicyContact": "اتصل بنا",
  "privacyPolicyContactContent": "إذا كانت لديك أي أسئلة بخصوص سياسة الخصوصية هذه، يرجى الاتصال بنا من خلال المعلومات المقدمة في صفحة الاتصال.",
  "privacyPolicyLastUpdated": "آخر تحديث",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "أي بوكيمون أنا؟",
  "whichPokemonAmISubtitle": "اكتشف أي بوكيمون يناسبك بشكل أفضل",
  "enterYourName": "أدخل اسمك",
  "namePlaceholder": "اسمك",
  "enterFavoriteColor": "اختر لونك المفضل",
  "enterBirthMonth": "اختر شهر ميلادك",
  "selectBirthMonth": "اختر الشهر",
  "enterPersonalityTrait": "اختر سمة شخصيتك",
  "selectPersonalityTrait": "اختر سمة",
  "findMyPokemon": "ابحث عن بوكيمون الخاص بي",
  "calculating": "جاري الحساب...",
  "yourPokemonIs": "بوكيمون الخاص بك هو",
  "pokemonDescription": "الوصف",
  "personalityMatch": "توافق الشخصية",
  "yourCompatibility": "توافقك",
  "downloadImage": "تحميل الصورة",
  "shareResult": "مشاركة النتيجة",
  "tryAgain": "حاول مرة أخرى",
  "results": "النتائج",
  "aboutTool": "حول هذه الأداة",
  "howToUse": "كيفية الاستخدام",
  "benefits": "الفوائد",
  "faq": "الأسئلة الشائعة",
  "conclusion": "الخلاصة",
  
  // Error messages
  "nameRequired": "الاسم مطلوب",
  "colorRequired": "يرجى اختيار لون",
  "monthRequired": "يرجى اختيار شهر",
  "traitRequired": "يرجى اختيار سمة شخصية",
  
  // Months
  "january": "يناير",
  "february": "فبراير",
  "march": "مارس",
  "april": "أبريل",
  "may": "مايو",
  "june": "يونيو",
  "july": "يوليو",
  "august": "أغسطس",
  "september": "سبتمبر",
  "october": "أكتوبر",
  "november": "نوفمبر",
  "december": "ديسمبر",
  
  // Personality Traits
  "brave": "شجاع",
  "calm": "هادئ",
  "timid": "خجول",
  "jolly": "مرح",
  "quiet": "صامت",
  "hasty": "متسرع",
  "careful": "حذر",
  "lonely": "وحيد",
  "bold": "جريء",
  "relaxed": "مسترخي",
  "impish": "مشاكس",
  "modest": "متواضع",
  
  // Additional translations for size matching feature
  "heightValid": "يرجى إدخال طول صحيح (1-300 سم)",
  "weightValid": "يرجى إدخال وزن صحيح (1-500 كجم)",
  "enterDetails": "أدخل تفاصيلك",
  "nameLabel": "الاسم",
  "heightLabel": "الطول",
  "weightLabel": "الوزن",
  "finding": "جاري البحث...",
  "errorFinding": "خطأ في العثور على بوكيمون الخاص بك",
  "matchResult": "بوكيمون {{name}} هو...",
  "similarityScore": "درجة التشابه",
  "downloadStarted": "جاري تحضير الصورة...",
  "downloadComplete": "تم تحميل الصورة بنجاح!",
  "shareText": "اكتشفت أنني {{pokemon}}! اكتشف أي بوكيمون أنت أيضًا!",
  
  // Size matching feature
  "enterHeightWeight": "أدخل طولك ووزنك — انظر أي بوكيمون يتطابق معك!",
  "whichPokemonMatchesSize": "أي بوكيمون يتطابق مع حجمك؟",
  "youAreMostLike": "أنت أشبه بـ",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Arabic)
  "pokemonRandomizerPageAboutTitle": "استكشف تجربة تخصيص بوكيمون المطلقة",
  "pokemonRandomizer_whatIsItTitle": "ما هي أداة تخصيص البوكيمون بالضبط؟",
  "pokemonRandomizer_featuresTitle": "الميزات الرئيسية لأداة تخصيص البوكيمون الخاصة بنا",
  "pokemonRandomizer_whyUseTitle": "لماذا تشرع في مغامرة مع أداة تخصيص البوكيمون؟",
  "pokemonRandomizer_gettingStartedTitle": "البدء: أول جولة لك مع أداة تخصيص البوكيمون",
  "pokemonRandomizer_faqTitle": "أداة تخصيص البوكيمون: الأسئلة الشائعة",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to Arabic)
  "pokemonRandomizerPageH1": "منشئ بوكيمون العشوائي",
  "pokemonRandomizerPageSubtitle": "أنشئ تجارب بوكيمون فريدة باستخدام أداة التوزيع العشوائي المتقدمة الخاصة بنا.",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Arabic)
  "madeBy": "صنع بواسطة",

  // Sub-Footer
  subFooterToolsTitle: "أدوات",
  subFooterRandomPokemonGeneratorLink: "منشئ بوكيمون العشوائي",
  subFooterPokemonRandomizerLink: "أداة توزيع بوكيمون عشوائيًا",
  subFooterWhichPokemonAmILink: "أي بوكيمون أنا؟",

  subFooterPokemonDatabaseTitle: "قاعدة بيانات بوكيمون",
  subFooterPokedexLink: "بوكيدكس (قريبًا)",
  subFooterTypeChartsLink: "مخططات الأنواع (قريبًا)",
  subFooterMoveListLink: "قائمة الحركات (قريبًا)",

  subFooterBlogTitle: "مدونة",
  subFooterLatestArticlesLink: "أحدث المقالات (قريبًا)",
  subFooterGuidesTutorialsLink: "أدلة وشروحات (قريبًا)"
};
